import React, { useState, useEffect } from "react";

import "./index.scss";
import axiosInstance from "../../../../services/api/API";
import CustomTable from "../../../../customComponents/CustomTable";
import { useNavigate } from "react-router-dom";
import ListFilters from "../../../Admin/OnBoardManagement/ListFilters";
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import viewIcon from "../../../../../Assets/icons/eye 1.svg";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import { IoMdClose } from "react-icons/io";
// Un-Checkbox.svg

const SupervisorPartList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [supervisorPartList, setSupervisorPartList] = useState([]);
  const [totalPartRecord, setTotalPartRecord] = useState(null);
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const [filterFormData, setFilterFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [filters, setFilters] = useState({});

  useEffect(() => {
    fetchSevicePartList();
  }, []);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchSevicePartList(newPage);
  };

  const fetchSevicePartList = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;

    try {
      const response = await axiosInstance.post(
        "/supervisorpartapproval/supervisorpartapprovallist",
        {
          business_partner_id: 1,
          fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
          toDate: allfilteredData?.toDate ? allfilteredData?.toDate : "",
          orderBy: "job_card_id desc",
          page,
          pageSize,
          searchText: searchTerm,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
        Satus: item?.solved == 0 ? "Pending" : "Done",
      }));
      setTotalRecords(response?.data?.data?.totalRecords);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
      setSupervisorPartList(formattedData);
      setTotalPartRecord(response?.data?.data);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const handleEdit = (rowData) => {
    navigate("supervison-part-details", {
      state: { data: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  const Job_Card_TABLE_HEADERS = [
    "Job Card No.",
    // "Business Partner ID",
    "Registration No.",
    "Customer Name",
    "Product Name",
    "Make",
    "Job Estimate Amount",
    "Outstanding Amt.",
    "Delivery Date",
    "Status",
    "Action",
  ];

  // job_estimate_amount

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    "Job Card No.": "job_card_no",
    // "Business Partner ID": "onboard_id",
    "Registration No.": "registration_no",
    "Customer Name": "customer_name",
    "Product Name": "product_name",
    Make: "make_name",
    "Job Estimate Amount": "job_estimate_amount",
    "Outstanding Amt.": "chargeable_amount",
    "Delivery Date": "Delivery_date",
    Status: "Satus",
    Action: [
      // {
      //   type: "edit",
      //   icon: editIcon,
      //   label: "Edit",
      // },
      {
        type: "view",
        icon: viewIcon,
        label: "View",
      },
    ],
  };

  useEffect(() => {
    fetchSevicePartList();
  }, [filters]);

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchSevicePartList();
  };

  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-4",
    },
  ];

  const handleSearch = () => {
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
    });
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event?.target?.value);
  };

  const clearSearchAndFetch =()=>{
    setSearchTerm('');
  }

  const handleKeyDown=(event)=>{
    if(event?.key==="Enter"){
    fetchSevicePartList();
    }
  }

  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div className="OnboardManagamentbuttonContainer col-md-4  mt-2 mb-2">
          <h5 style={{fontWeight:"600"}} >Supervisor Part Approval</h5>
        </div>
        <div className=" col-md-8 mt-2 mb-2 totalvaluescontainer ">
          <div className="topleftdataContainer">
            <div className="listTopDataValueText">
              {totalPartRecord?.total || 0}
            </div>
            <div>Approval Request</div>
          </div>

          <div className="topleftdataContainer">
            <div className="listTopDataValueText">
              {totalPartRecord?.total_pending || 0}
            </div>
            <div>Pending Approval</div>
          </div>
          <div
            // key={}
            className="topleftdataContainer"
          >
            <div className="listTopDataValueText">
              {totalPartRecord?.total_approve || 0}
            </div>
            <div>Approved</div>
          </div>
        </div>
      </div>
      <div className="tableWrapper">
        <div className="filterView">
          <div className="filterLeftView pt-4 col-md-4 gap-2">
            <h5 style={{fontWeight:"600"}} >Supervisor Approval List</h5>
            <div className="searchinput-wrapper">
              <input
                type="text"
                className="searchinput"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchInputChange}
                onKeyDown={handleKeyDown}
              />
                 {searchTerm ? (
                <IoMdClose size={22} className="searchinput-close-icon" onClick={clearSearchAndFetch} />
              ) : (
                <img src={searchIcon} alt="Search" className="searchinput-icon" />
              )}
            </div>
          </div>
          <div className="filterRightView col-md-8 gap-2">
            <h5 style={{paddingTop:"30px"}} >Filter By</h5>
            {/* <ListFilters /> */}
            <ListLogisticsFilters
              formConfig={PhysicalStockTakingInputs}
              formData={filterFormData}
              setFormData={setFilterFormData}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              handleSearch={handleSearch}
              handleClear={clearFilter}
              // onSubmit={handleFormSubmit}
            />
          </div>
        </div>

        <CustomTable
          data={supervisorPartList || []}
          headers={Job_Card_TABLE_HEADERS}
          keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
          onEdit={handleEdit} // Pass the handleEdit function
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          handleViewButton={handleEdit}
          totalRecords={totalRecords}
        />
      </div>
    </div>
  );
};

export default SupervisorPartList;
